(function(){
  'use strict';
  if(window.__oatzHomeInit)return;window.__oatzHomeInit=true;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn){if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}

  function initParallax(){
    var els=[].slice.call(document.querySelectorAll('[data-oatz-parallax]'));
    if(!els.length||reduce)return;
    var running=false;
    function frame(){
      var v=window.innerHeight||document.documentElement.clientHeight;
      var vis=false;
      els.forEach(function(s){
        var r=s.getBoundingClientRect();
        if(r.bottom<-80||r.top>v+80)return;
        vis=true;
        var bg=s.querySelector('[data-oatz-parallax-bg]');if(!bg)return;
        var prog=(r.top+r.height/2-v/2)/v;
        bg.style.transform='translate3d(0,'+(prog*150).toFixed(1)+'px,0)';
      });
      if(vis){requestAnimationFrame(frame);}else{running=false;}
    }
    function kick(){if(!running){running=true;requestAnimationFrame(frame);}}
    window.addEventListener('scroll',kick,{passive:true});
    window.addEventListener('resize',kick,{passive:true});
    window.addEventListener('touchmove',kick,{passive:true});
    kick();
    setInterval(kick,500);
  }

  function initVideo(){
    [].slice.call(document.querySelectorAll('video[data-oatz-video]')).forEach(function(v){
      v.muted=true;v.setAttribute('muted','');
      var p=v.play();if(p&&p.catch){p.catch(function(){});}
    });
  }

  function initReveal(){
    var els=[].slice.call(document.querySelectorAll('[data-oatz-reveal]'));
    if(!els.length)return;
    if(reduce||!('IntersectionObserver'in window)){els.forEach(function(e){e.classList.add('is-in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}});},{threshold:.15});
    els.forEach(function(e){io.observe(e);});
  }

  /* Carrossel: no celular o dedo resolve, no desktop não havia como avançar —
     a barra de rolagem está escondida e o mouse não arrasta sozinho. Daí setas,
     arraste com o mouse e o estado das pontas, que diz quando acabou a fileira. */
  function initCarousel(){
    [].slice.call(document.querySelectorAll('[data-oatz-carousel]')).forEach(function(track){
      var wrap=track.closest?(track.closest('[data-oatz-carousel-wrap]')||track.parentNode):track.parentNode;
      var prev=wrap.querySelector('[data-oatz-carousel-prev]');
      var next=wrap.querySelector('[data-oatz-carousel-next]');
      /* O gap sai do CSS: cada seção tem o seu (14, 18, 20px) e chutar 24 desalinhava o snap. */
      function gap(){var g=parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap);return isNaN(g)?20:g;}
      function step(){var c=track.children[0];return c?c.getBoundingClientRect().width+gap():300;}
      function slack(){return track.scrollWidth-track.clientWidth;}

      /* 2px de folga: com zoom do navegador o scrollLeft vira fracionário e a seta
         ficava acesa sem ter para onde ir. */
      function sync(){
        var overflow=slack()>2;
        wrap.classList.toggle('is-scrollable',overflow);
        if(prev){prev.disabled=!overflow||track.scrollLeft<=2;}
        if(next){next.disabled=!overflow||track.scrollLeft>=slack()-2;}
      }
      if(prev){prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});}
      if(next){next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});}
      track.addEventListener('scroll',sync,{passive:true});
      window.addEventListener('resize',sync,{passive:true});
      if('ResizeObserver'in window){new ResizeObserver(sync).observe(track);}

      /* Arraste com o mouse. Ponteiro grosso só (mouse), porque no toque o
         scroll nativo já funciona e sequestrar o gesto quebraria o snap. */
      if(window.matchMedia&&window.matchMedia('(pointer:fine)').matches){
        var down=false,startX=0,startLeft=0,moved=0;
        track.addEventListener('pointerdown',function(e){
          if(e.button!==0)return;
          down=true;moved=0;startX=e.clientX;startLeft=track.scrollLeft;
        });
        track.addEventListener('pointermove',function(e){
          if(!down)return;
          var dx=e.clientX-startX;
          if(Math.abs(dx)>3&&!track.hasPointerCapture(e.pointerId)){track.setPointerCapture(e.pointerId);}
          if(Math.abs(dx)>moved){moved=Math.abs(dx);}
          if(moved>3){track.classList.add('is-dragging');track.scrollLeft=startLeft-dx;}
        });
        /* Sem isto, soltar o mouse depois de arrastar abria o card sob o cursor:
           o arraste termina em click. 6px separa arrastar de clicar. */
        track.addEventListener('click',function(e){
          if(moved>6){e.preventDefault();e.stopPropagation();}
        },true);
        ['pointerup','pointercancel','pointerleave'].forEach(function(ev){
          track.addEventListener(ev,function(e){
            if(!down)return;
            down=false;track.classList.remove('is-dragging');
            if(track.hasPointerCapture&&track.hasPointerCapture(e.pointerId)){track.releasePointerCapture(e.pointerId);}
            setTimeout(function(){moved=0;},0);
          });
        });
      }
      sync();
    });
  }

  function initBlogRecipes(){
    var grids=[].slice.call(document.querySelectorAll('[data-oatz-blog-grid]'));
    if(!grids.length)return;
    var state=grids.map(function(grid){
      return {
        perPage:parseInt(grid.getAttribute('data-per-page'),10)||8,
        cardsWrap:grid.querySelector('[data-oatz-blog-cards]'),
        nav:grid.querySelector('[data-oatz-blog-pagination]'),
        page:1
      };
    });

    function render(s){
      if(!s.cardsWrap)return;
      var cards=[].slice.call(s.cardsWrap.querySelectorAll('[data-oatz-recipe]'));
      var visible=cards.filter(function(c){return !c.classList.contains('is-filtered-out');});
      var totalPages=Math.max(1,Math.ceil(visible.length/s.perPage));
      if(s.page>totalPages)s.page=totalPages;
      cards.forEach(function(c){c.classList.remove('is-page-hidden');});
      visible.forEach(function(c,i){
        if(Math.floor(i/s.perPage)+1!==s.page)c.classList.add('is-page-hidden');
      });
      if(!s.nav)return;
      s.nav.innerHTML='';
      if(totalPages<=1)return;
      function btn(label,disabled,active,onClick){
        var b=document.createElement('button');
        b.type='button';
        b.className='oatz-pg__btn'+(active?' is-active':'');
        b.textContent=label;
        if(disabled)b.disabled=true;
        b.addEventListener('click',onClick);
        return b;
      }
      s.nav.appendChild(btn('‹',s.page===1,false,function(){if(s.page>1){s.page--;render(s);}}));
      for(var p=1;p<=totalPages;p++){
        (function(p){s.nav.appendChild(btn(String(p),p===s.page,p===s.page,function(){s.page=p;render(s);}));})(p);
      }
      s.nav.appendChild(btn('›',s.page===totalPages,false,function(){if(s.page<totalPages){s.page++;render(s);}}));
    }

    state.forEach(render);

    var filterBtns=[].slice.call(document.querySelectorAll('[data-oatz-blog-filter]'));
    if(filterBtns.length){
      filterBtns.forEach(function(btn){
        btn.addEventListener('click',function(){
          filterBtns.forEach(function(b){b.classList.remove('is-active');b.setAttribute('aria-pressed','false');});
          btn.classList.add('is-active');btn.setAttribute('aria-pressed','true');
          var cat=btn.getAttribute('data-category')||'';
          state.forEach(function(s){
            if(!s.cardsWrap)return;
            var cards=[].slice.call(s.cardsWrap.querySelectorAll('[data-oatz-recipe]'));
            cards.forEach(function(c){
              var match=!cat||c.getAttribute('data-category')===cat;
              c.classList.toggle('is-filtered-out',!match);
            });
            s.page=1;render(s);
          });
        });
      });
    }
  }

  function initProductBuybox(){
    [].slice.call(document.querySelectorAll('.oatz-buybox')).forEach(function(box){
      var dataEl=box.querySelector('[data-oatz-buybox-variants-json]');
      var variants=[];
      if(dataEl){try{variants=JSON.parse(dataEl.textContent);}catch(e){variants=[];}}
      var variantIdInput=box.querySelector('[data-oatz-buybox-variantid]');
      var qtyInput=box.querySelector('[data-oatz-buybox-qtyinput]');
      var priceEl=box.querySelector('[data-oatz-buybox-price] .price__last .price-item');
      var pixTextEl=box.querySelector('[data-oatz-buybox-pix-text]');
      var installmentsEl=box.querySelector('[data-oatz-buybox-installments]');
      var addBtn=box.querySelector('.oatz-buybox__addbtn');

      function findVariant(id){
        for(var i=0;i<variants.length;i++){if(String(variants[i].id)===String(id))return variants[i];}
        return null;
      }

      function syncPriceDisplay(id){
        var v=findVariant(id);
        if(!v)return;
        if(priceEl)priceEl.textContent=v.price;
        if(pixTextEl)pixTextEl.textContent=v.pix;
        if(installmentsEl)installmentsEl.textContent=v.installments;
        if(addBtn){
          addBtn.disabled=!v.available;
          addBtn.textContent=v.available?'Adicionar ao carrinho':'Esgotado';
        }
      }

      function selectVariant(row){
        var id=row.getAttribute('data-variant-id');
        box.querySelectorAll('[data-oatz-buybox-variant]').forEach(function(r){r.classList.remove('is-selected');});
        row.classList.add('is-selected');
        var radio=row.querySelector('input[type="radio"]');
        if(radio)radio.checked=true;
        if(variantIdInput)variantIdInput.value=id;
        var qtyVal=row.querySelector('[data-oatz-qty-value]');
        if(qtyVal){
          if(qtyVal.textContent==='0')qtyVal.textContent='1';
          if(qtyInput)qtyInput.value=qtyVal.textContent;
        }
        syncPriceDisplay(id);
      }

      box.querySelectorAll('[data-oatz-buybox-variant]').forEach(function(row){
        row.addEventListener('click',function(e){
          if(row.classList.contains('is-soldout'))return;
          if(e.target.closest('[data-oatz-qty-minus],[data-oatz-qty-plus]'))return;
          selectVariant(row);
        });
      });

      box.querySelectorAll('[data-oatz-qty-minus],[data-oatz-qty-plus]').forEach(function(btn){
        btn.addEventListener('click',function(){
          var row=btn.closest('[data-oatz-buybox-variant]');
          if(row&&!row.classList.contains('is-selected'))return;
          var valEl=btn.parentNode.querySelector('[data-oatz-qty-value]');
          if(!valEl)return;
          var val=parseInt(valEl.textContent,10)||0;
          if(btn.hasAttribute('data-oatz-qty-minus'))val=Math.max(1,val-1);
          else val=val+1;
          valEl.textContent=val;
          if(qtyInput)qtyInput.value=val;
        });
      });
    });
  }

  function initFreteCalc(){
    [].slice.call(document.querySelectorAll('[data-oatz-frete]')).forEach(function(box){
      var input=box.querySelector('[data-oatz-frete-cep]');
      var btn=box.querySelector('[data-oatz-frete-submit]');
      var result=box.querySelector('[data-oatz-frete-result]');
      if(!input||!btn||!result)return;
      input.addEventListener('input',function(){
        var digits=input.value.replace(/\D/g,'').slice(0,8);
        input.value=digits.length>5?digits.slice(0,5)+'-'+digits.slice(5):digits;
      });
      btn.addEventListener('click',function(){
        var digits=input.value.replace(/\D/g,'');
        if(digits.length!==8){result.textContent='Digite um CEP válido.';return;}
        result.textContent='Calculando...';
        fetch('https://viacep.com.br/ws/'+digits+'/json/').then(function(r){return r.json();}).then(function(data){
          if(data.erro){result.textContent='CEP não encontrado.';return;}
          result.textContent='Entrega para '+data.localidade+'/'+data.uf+' calculada no carrinho.';
        }).catch(function(){result.textContent='Não foi possível consultar o CEP agora.';});
      });
    });
  }

  function initWishlistToggle(){
    [].slice.call(document.querySelectorAll('[data-oatz-wishlist]')).forEach(function(btn){
      btn.addEventListener('click',function(){
        var on=btn.classList.toggle('is-active');
        btn.setAttribute('aria-pressed',on?'true':'false');
      });
    });
  }

  function initFlavorPicker(){
    [].slice.call(document.querySelectorAll('[data-oatz-flavor-list]')).forEach(function(list){
      var box=list.closest('.oatz-buybox');
      if(!box)return;
      var form=box.querySelector('.oatz-buybox__form');
      var qtyInput=box.querySelector('[data-oatz-buybox-qtyinput]');
      var addBtn=box.querySelector('.oatz-buybox__addbtn');

      function rows(){return [].slice.call(list.querySelectorAll('[data-oatz-flavor-row]'));}

      rows().forEach(function(row){
        var valEl=row.querySelector('[data-oatz-flavor-qty-value]');
        var minus=row.querySelector('[data-oatz-flavor-qty-minus]');
        var plus=row.querySelector('[data-oatz-flavor-qty-plus]');
        if(!valEl||!minus||!plus)return;
        var isActive=row.classList.contains('is-active');

        function setVal(v){
          v=Math.max(0,v);
          valEl.textContent=v;
          if(isActive&&qtyInput)qtyInput.value=Math.max(1,v);
        }

        minus.addEventListener('click',function(){setVal((parseInt(valEl.textContent,10)||0)-1);});
        plus.addEventListener('click',function(){
          if(row.getAttribute('data-available')==='false')return;
          setVal((parseInt(valEl.textContent,10)||0)+1);
        });

        var href=row.getAttribute('data-oatz-flavor-href');
        if(href){
          row.addEventListener('click',function(e){
            if(e.target.closest('.oatz-buybox__flavorrow-qty'))return;
            window.location.href=href;
          });
        }
      });

      if(!form)return;
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var items=[];
        rows().forEach(function(row){
          var valEl=row.querySelector('[data-oatz-flavor-qty-value]');
          var qty=parseInt(valEl.textContent,10)||0;
          if(qty>0&&row.getAttribute('data-available')!=='false'){
            items.push({id:parseInt(row.getAttribute('data-variant-id'),10),quantity:qty});
          }
        });
        if(!items.length)return;
        var originalText=addBtn?addBtn.textContent:'';
        if(addBtn){addBtn.disabled=true;addBtn.textContent='Adicionando...';}
        fetch(window.Shopify.routes.root+'cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:items})
        }).then(function(r){return r.json();}).then(function(){
          if(typeof window.updateCart==='function')window.updateCart();
          rows().forEach(function(row){
            if(!row.classList.contains('is-active')){
              var valEl=row.querySelector('[data-oatz-flavor-qty-value]');
              if(valEl)valEl.textContent='0';
            }
          });
          if(addBtn){addBtn.disabled=false;addBtn.textContent=originalText;}
        }).catch(function(){
          if(addBtn){addBtn.disabled=false;addBtn.textContent=originalText;}
        });
      });
    });
  }

  ready(function(){initParallax();initVideo();initReveal();initCarousel();initBlogRecipes();initProductBuybox();initFreteCalc();initWishlistToggle();initFlavorPicker();});
})();
